var THREE         = require("three"); 
var PositionHandleView  = require("./../abstract/positionHandleView.js");
var lib_core      = require("lib-core");

var XHandleView = function (model, editorView, handleId, config) {
    PositionHandleView.call(this, model, editorView, handleId, config);
}
lib_core.inherit(XHandleView, PositionHandleView);

XHandleView.prototype.repositionMesh = function(mesh, position, rotation){
    var matrix = (new THREE.Matrix4())
    matrix.setPosition( position.toThreejs() );
    mesh.matrix = matrix;
}

XHandleView.prototype.buildMesh = function(){
    var obj = new THREE.Object3D();
    obj.matrixAutoUpdate = false;

    var geom = this.buildGeometry(3)//.rotateX(Math.PI/2);
    var mesh = new THREE.Mesh(geom, this.material);
    
    obj.add(mesh);
    return obj;
}

XHandleView.prototype.buildGeometry = function(radius){
    var handleSize = this.config.size * (radius/10);
    var handleSpacing = this.extraRadius * (radius/10);

    var height = radius/2;
    var rad = radius/20;
    var shape = new THREE.ConeGeometry( 
        rad, 
        height, 
        32 );
    //shape.translate(0, radius + handleSize + handleSpacing + radius/2, 0);
    shape.translate(0, height/2 + rad, 0);
    shape.rotateZ(-Math.PI/2);
    return shape;
}


 
XHandleView.prototype.hoverChanged = function(value){
    if(value){
        this.material.transparent = false;
    } else {
        this.material.transparent = true;
    }
} 

module.exports = XHandleView;